<template>
  <base-container ref="container" :isLoading="loading">
    <artisan-group>
      <el-row slot="header" type="flex" align="middle">
        <span style="margin: 0 10px 0 0">录入时间:</span>
        <el-date-picker
          style="width: 350px"
          size="mini"
          v-model="filterDate"
          type="datetimerange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :clearable="false"
          valueFormat="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <span style="margin: 0 10px 0 20px">病区:</span>
        <el-select v-model="wardId" size="mini" placeholder="请选择">
          <el-option
            v-for="item in wards"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          style="margin: 0 10px"
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="loadQuery"
        >
          查询
        </el-button>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div id="bedIdleChart" style="height: 500px"></div>
        </el-col>
        <el-col :span="8">
          <div id="bedManChart" style="height: 500px"></div>
        </el-col>
        <el-col :span="8">
          <div id="bedWomenChart" style="height: 500px"></div>
        </el-col>
      </el-row>
    </artisan-group>
    <artisan-group title="空床日志">
      <el-table :data="list" style="width: 100%">
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="录入时间"
          width="170"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="doctorName"
          label="医疗组"
          width="150"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="idleDate"
          label="空闲日期"
          width="120"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="idleCount"
          label="空床数量"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="idleCount"
          label="空床数量(总)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="manCount"
          label="空床数量(男)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="womenCount"
          label="空床数量(女)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="userName"
          label="录入人"
        >
        </el-table-column>
      </el-table>
    </artisan-group>
  </base-container>
</template>

<script>
import moment from "moment";
import { idleLogs } from "@/api/bed/idle";
import { getWards } from "@/api/bed/ward";
import * as echarts from "echarts";
export default {
  data() {
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    return {
      loading: false,
      filterDate: [start, new Date()],
      wardId: "",
      wards: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              end.setHours(23);
              const start = new Date();
              start.setHours(0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近一月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近三月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      idleChart: "",
      manChart: "",
      womenChart: "",
      idleOption: {
        title: {
          text: "空闲床位(总)",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : <b>{c}</b> ({d}%)",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 10,
          top: 20,
          bottom: 20,
          data: [],
        },
        series: [
          {
            type: "pie",
            radius: "40%",
            label: {
              formatter: "{b} : {c} ({d}%)",
            },
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      manOption: {
        title: {
          text: "空闲床位(男)",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : <b>{c}</b> ({d}%)",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 10,
          top: 20,
          bottom: 20,
          data: [],
        },
        series: [
          {
            type: "pie",
            radius: "40%",
            label: {
              formatter: "{b} : {c} ({d}%)",
            },
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      womenOption: {
        title: {
          text: "空闲床位(女)",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : <b>{c}</b> ({d}%)",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 10,
          top: 20,
          bottom: 20,
          data: [],
        },
        series: [
          {
            type: "pie",
            radius: "40%",
            label: {
              formatter: "{b} : {c} ({d}%)",
            },
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    getWards().then((res) => {
      this.wards = res.data.data;
      if (this.wards.length) {
        this.wardId = this.wards[0].id;
        this.loadQuery();
      }
    });
  },
  methods: {
    loadQuery() {
      this.loading = true;
      let start = moment(this.filterDate[0]).format("YYYY-MM-DD HH:mm:ss");
      let end = moment(this.filterDate[1]).format("YYYY-MM-DD HH:mm:ss");
      idleLogs(this.wardId, start, end)
        .then((res) => {
          this.list = res.data.data;
          let map = {};
          this.list.forEach((c) => {
            if (map[c.doctorId]) {
              map[c.doctorId].idleCount += c.idleCount;
              map[c.doctorId].manCount += c.manCount;
              map[c.doctorId].womenCount += c.womenCount;
              map[c.doctorId].dates.push(c);
            } else {
              map[c.doctorId] = {
                doctorName: c.doctorName,
                idleCount: c.idleCount,
                manCount: c.manCount,
                womenCount: c.womenCount,
                dates: [c],
              };
            }
          });
          this.idleOption.legend.data = [];
          this.idleOption.series[0].data = [];
          this.manOption.legend.data = [];
          this.manOption.series[0].data = [];
          this.womenOption.legend.data = [];
          this.womenOption.series[0].data = [];
          for (const key in map) {
            this.idleOption.legend.data.push(map[key].doctorName);
            this.idleOption.series[0].data.push({
              name: map[key].doctorName,
              value: map[key].idleCount,
            });
            this.manOption.legend.data.push(map[key].doctorName);
            this.manOption.series[0].data.push({
              name: map[key].doctorName,
              value: map[key].manCount,
            });
            this.womenOption.legend.data.push(map[key].doctorName);
            this.womenOption.series[0].data.push({
              name: map[key].doctorName,
              value: map[key].womenCount,
            });
          }
          if (!this.idleChart) {
            this.idleChart = echarts.init(
              document.getElementById("bedIdleChart")
            );
          }
          this.idleChart.setOption(this.idleOption, true);
          if (!this.manChart) {
            this.manChart = echarts.init(
              document.getElementById("bedManChart")
            );
          }
          this.manChart.setOption(this.manOption, true);
          if (!this.womenChart) {
            this.womenChart = echarts.init(
              document.getElementById("bedWomenChart")
            );
          }
          this.womenChart.setOption(this.womenOption, true);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    metaInited(option) {
      option.columns.find((c) => c.code == "createTime").searchSlot = true;
    },
    handleQuery(param) {
      if (this.filterDate.length) {
        let start = moment(this.filterDate[0]).format("YYYY-MM-DD HH:mm:ss");
        let end = moment(this.filterDate[1]).format("YYYY-MM-DD HH:mm:ss");
        param.createTime = start + "," + end;
      }
      return param;
    },
  },
};
</script>

<style scoped>
.el-tabs >>> .el-tabs__content {
  height: 100%;
  overflow: auto;
}
</style>
